//@flow
import React, { Component } from 'react';
import { connect } from "react-redux";
import { setToGroupType } from "../../../actions";
import { buildIframeUrl, smSourceAuthCheck, Wrapper, updateStep, Modal } from "h-signup";
import { SubTitle } from "../GetStarted/styledComponents";
import SVG from 'react-svg-inline';
import { CircularProgress } from '@hiver/hiver-ui-kit'

import { 
	VerifyButton, 
	ButtonText, 
	Title, HorizontalLine, 
	OrContainer, 
	ErrorMessage, 
	ErrorTitle, 
	ErrorAction,
	VerifyTitleStyle,
	DividerTextStyle,
	SubTitleStyle
} from './styledComponents'
import GoogleRound from '../../../../common/images/google-g-logo.svg';
import VerifyRound from '../../../../common/images/google-group-icon.svg';
import ErrorIcon from '../../../../common/images/icecream-drop.png'
import { sendGenricTrackingEvent } from 'h-commons';
import { useGetSmToken } from './useGetSmToken';
class Verify extends Component<Props, State> {
	
	$key: ModalActions;
	$value: () => mixed
	constructor(props: Props) {
		super(props);
		this.state = {
			showErrorModal: false,
			errorMessage: null,
			errorTitle: null,
			verifyInProgress: false,
			verifyAction: 'verifyGroup'
		}
	}

	verifyUsingGoogle = (token) => {
		let response;
		const { userDetails, smData } = this.props;
		const { verifyInProgress } = this.state;
		if (verifyInProgress) return;
        const popUpDimensions = 'width=1200 height=600 left=150 top=150';
		const url = `/mailboxAuth?smid=${smData.sharedmailboxid}&auth_token=${token}`;
		const googleSignupPopup = window.open(buildIframeUrl(url, userDetails.id), 'OpenID', popUpDimensions);
		this.setState({ verifyInProgress: true, verifyAction: 'verifyUsingGoogle'  },
			async () => {
				try {
					response = await smSourceAuthCheck(googleSignupPopup);
				} catch(err) {
					response = err;
				}
				this.setState({ verifyInProgress: false});
				switch(response) {
					case "success": 
						sendGenricTrackingEvent('validatedSharedMailboxSignup', { type: 'user', state: 'success', userid: userDetails.id });
						return this.props.updateStep(response);
					case "mismatch":
						sendGenricTrackingEvent('validatedSharedMailboxSignup', { type: 'user', state: 'mismatch', userid: userDetails.id });
						return 	this.toggleErrorMessage(
							"Address Mismatch",
							`You specified "${smData.source_email}" as Shared Mailbox but you authorized some other email address.`
						);
					case "signInClosed":
						sendGenricTrackingEvent('validatedSharedMailboxSignup', { type: 'user', state: 'signInClosed', userid: userDetails.id });
						return this.toggleErrorMessage(
							"Sign in canceled",
							"You may have closed the verification sign in window before we could verify your email address."
						);
					default:
						console.error(response);
						sendGenricTrackingEvent('validatedSharedMailboxSignup', { type: 'user', state: 'failure' , userid: userDetails.id});
						return this.toggleErrorMessage(
							"Error",
							'An unexpected error occured. We are sorry for the inconvenience. Please, contact "support@hiverhq.com".'
						);
				}
				
			}
		);
		
	}
	
	toggleErrorMessage(title?: string, message?: string) {
		this.setState({
			errorMessage: message || null,
			errorTitle: title || null,
			showErrorModal: !!message || false,
		})
	}

	verifyGroup = () => {
		const { sharedmailboxid } = this.props.smData;
		const { verifyInProgress } = this.state;
		if (verifyInProgress) return;
		this.setState({ verifyInProgress: true, verifyAction: 'verifyGroup' });
		this.props.verifyGroupType(sharedmailboxid, (success) => {
			if(!success) {
				sendGenricTrackingEvent('validatedSharedMailboxSignup', { type: 'group', state: 'failure' })
				this.toggleErrorMessage(
					"Error",
					'An unexpected error occured. We are sorry for the inconvenience. Please, contact "support@hiverhq.com".'
				);
			}
			this.setState({ verifyInProgress: false }, () => {
				sendGenricTrackingEvent('validatedSharedMailboxSignup', { type: 'group', state: 'success' })
				success && this.props.updateStep('success')
			});
		});
	}

	modalClosed = () =>  {
		this.toggleErrorMessage();
	}

	modalAction = (): void => {
		const { verifyAction } = this.state;
		this.toggleErrorMessage();
		this[verifyAction].apply(this, []);
	}

	renderErrorModal() {
		const { showErrorModal, errorMessage, errorTitle } = this.state;
		if (!showErrorModal) 
			return '';
		return [
			<img key="error-icon" src={ErrorIcon} />,
			<ErrorTitle key="error-title">{errorTitle}</ErrorTitle>,
			<ErrorMessage key="error-msg">{errorMessage}</ErrorMessage>,
			<ErrorAction onClick={this.modalAction} key="error-action">Try Again</ErrorAction>
		]
	}
	handleAuthAndVerify(){
		const { fetchSmToken, isSmTokenLoading } = this.props;
		if( isSmTokenLoading ) return;
		const { id: userId } = this.props.userDetails;
		fetchSmToken(userId).then((token) => {
			this.verifyUsingGoogle(token);
		});
	}
	renderVerifyButton(source) {
		const map = {
			'verifyUsingGoogle': {
				clickHandler: this.handleAuthAndVerify.bind(this),
				label: 'Connect Google',
				icon: GoogleRound
			},
			'verifyGroup': {
				clickHandler: this.verifyGroup,
				label: 'Verify Setup',
				icon: VerifyRound
			}
		}
		let icon;
		const { verifyInProgress, verifyAction } = this.state;
		if (verifyInProgress && verifyAction === source)
			icon = <CircularProgress size={30} style={{marginLeft: "17px"}}/>
		else 
			icon = <SVG svg={map[source].icon} width="26px" height="26px" className="flaunt-verify-icon" />
		return <VerifyButton width="212px" onClick={map[source].clickHandler}>
			{ icon  }
			<ButtonText> { map[source].label}</ButtonText>
		</VerifyButton>
	}
	

	render() {
		const boldFont = {fontWeight: 600}
		const { smData, userDetails } = this.props;
		
		return (
			<Wrapper>
				<Title style={VerifyTitleStyle}><span style={boldFont}>I have a password </span> for this account</Title>
				<SubTitle marginBottom="29px" style={{width: "435px"}}>
					<span style={SubTitleStyle}>
						<span style={boldFont}>{smData.source_email}</span> is a Gsuite/Gmail account. <br />
						All incoming mails to this ID will be visible in your shared <br/>
						mailbox with all its users
					</span>
				</SubTitle>
				{ this.renderVerifyButton('verifyUsingGoogle')}
				<OrContainer>
					<HorizontalLine></HorizontalLine>
					<span style={DividerTextStyle}>or</span>
					<HorizontalLine></HorizontalLine>
				</OrContainer>
				<Title style={VerifyTitleStyle}><span style={boldFont}>I do not have a password</span> for this account</Title>
				<SubTitle marginBottom="29px" style={{width: "435px"}}>
					<span style={SubTitleStyle}>
						<span style={boldFont}>{smData.source_email}</span> is a <span style={boldFont}>Google Group and does not have a password</span>.
						Emails sent to this ID should automatically get forwarded to <q>{userDetails.email}</q>
					</span>
				</SubTitle>
				{ this.renderVerifyButton('verifyGroup')}
				<Modal open={this.state.showErrorModal} onClose={this.modalClosed}>
					{ this.renderErrorModal() }
				</Modal>
			</Wrapper>
		)

	}
}

type Props ={
	verifyGroupType: Function,
	smData: Object,
	userDetails: Object,
	updateStep: Function
}
type ModalActions = "verifyGroup" | "verifyUsingGoogle";

type State = {
	showErrorModal: boolean,
	errorMessage: string | null,
	errorTitle: string | null,
	verifyInProgress: boolean,
	verifyAction: ModalActions
}
const mapStateToProps = ({ smData, userDetails }) => {
	return {
		smData,
		userDetails
	}
}

const mapDispatchToProps = (dispatch: Function) => {
	return {
		verifyGroupType: (smid, cb) => {
			dispatch(setToGroupType(smid, cb))
		},
		updateStep: (changeToRoute) => dispatch(updateStep(changeToRoute))
	}
}

const VerifyWrapper = (props) => {
    const { isLoading, fetchSmToken} = useGetSmToken();
    return (
        <Verify
            {...props}
            fetchSmToken={fetchSmToken}
            isSmTokenLoading={isLoading}
        />
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyWrapper);